import { useContext } from "react";
import UtilContext from "../contexts/util.context";

export default () =>{
    const { setSMessageE, setTitle, setTypeError, showToast } = useContext( UtilContext );
    const openToast = ( type:string, title:string, message:string )=>{
        setTitle(title);
        setSMessageE(message)
        setTypeError(type);
        showToast(true);
    }
    const closeToast = ()=>{
        showToast(false);
    }
    return { openToast, closeToast };
} 